import type { LogContext, Team } from '../types';

export abstract class AbstractLogger {
  public abstract log(
    message: string,
    teams: Array<Team>,
    ...optionalParams: Array<unknown>
  ): void;

  public abstract info(
    message: string,
    teams: Array<Team>,
    ...optionalParams: Array<unknown>
  ): void;

  public abstract error(
    message: string,
    teams: Array<Team>,
    ...optionalParams: Array<unknown>
  ): void;

  public abstract success(
    message: string,
    teams: Array<Team>,
    ...optionalParams: Array<unknown>
  ): void;

  public abstract refreshContext(context: LogContext): void;
}
